var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 25C19.9614 25 25.334 19.6274 25.334 13C25.334 6.37258 19.9614 1 13.334 1C6.70657 1 1.33398 6.37258 1.33398 13C1.33398 19.6274 6.70657 25 13.334 25Z",
    stroke: "#ADBEEB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4261 9.92865H15.529C15.6304 9.92865 15.7128 9.85105 15.7128 9.75544V8.71618C15.7128 8.62057 15.6304 8.54297 15.529 8.54297H14.4261C13.3114 8.54297 12.4041 9.39759 12.4041 10.4483V11.6607H11.1174C11.0159 11.6607 10.9336 11.7383 10.9336 11.834V12.8732C10.9336 12.9688 11.0159 13.0464 11.1174 13.0464H12.4041V16.6838C12.4041 16.7795 12.4865 16.857 12.5879 16.857H13.6908C13.7923 16.857 13.8746 16.7795 13.8746 16.6838V13.0464H15.1613C15.2404 13.0464 15.3106 12.9986 15.336 12.928L15.7036 11.8887C15.7223 11.836 15.7128 11.7778 15.6782 11.7325C15.6433 11.6874 15.5881 11.6607 15.529 11.6607H13.8746V10.4483C13.8746 10.1618 14.122 9.92865 14.4261 9.92865Z",
    fill: "#1E3679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMedium);
export default __webpack_public_path__ + "static/media/facebookMedium.dbd3718813621c8cdc4923b464dcfdf2.svg";
export { ForwardRef as ReactComponent };